import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BrowseFilter, FilterNamesEnum } from '../models/filter';
import {
  FilterOption,
  getClimbCategoryFilterOptions,
  getDifficultyFilterOptions,
  getDistanceFilterOptions,
  getDurationFilterOptions,
  getEquipmentFilterOptions,
  getInAppFilterOptions,
  getLangFilterOptions,
  getPowerFilterOptions,
  getProgressFilterOptions,
  getQualityFilterOptions,
  getRegionFilterOptions,
  getSearchModeFilterOptions,
  getSlopeFilterOptions,
  getSoundFilterOptions,
  getSpeedFilterOptions,
  getTagFilterOptions,
  getWorkoutTypeFilterOptions,
} from '../models/filter-options';
import { Sport } from '../models/sport';
import { Tag } from '../models/tag.interface';
import { TagStore } from '../store/tag/tag.store';
import { Vehicle } from '../models/vehicle.interface';
import { VehicleStore } from '../store/vehicle/vehicle.store';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  private tags: Tag[] = [];
  private vehicles: Vehicle[] = [];

  constructor(
    private translateService: TranslateService,
    private tagStore: TagStore,
    private vehicleStore: VehicleStore
  ) {
    this.tagStore.tags$.subscribe((tags: Tag[]) => {
      this.tags = tags;
    });
    this.vehicleStore.vehicles$.subscribe(
      (vehicles: Vehicle[]) => (this.vehicles = vehicles)
    );
  }

  getFilterOptions(filter: BrowseFilter, sport: Sport): FilterOption[] {
    switch (filter.name) {
      case FilterNamesEnum.SearchMode:
        return getSearchModeFilterOptions();
      case FilterNamesEnum.WorkoutType:
        return getWorkoutTypeFilterOptions(sport);
      case FilterNamesEnum.Duration:
        return getDurationFilterOptions();
      case FilterNamesEnum.Distance:
        return getDistanceFilterOptions();
      case FilterNamesEnum.Slope:
        return getSlopeFilterOptions();
      case FilterNamesEnum.Difficulty:
        return getDifficultyFilterOptions();
      case FilterNamesEnum.Quality:
        return getQualityFilterOptions();
      case FilterNamesEnum.Progress:
        return getProgressFilterOptions();
      case FilterNamesEnum.Sound:
        return getSoundFilterOptions();
      case FilterNamesEnum.Speed:
        return getSpeedFilterOptions();
      case FilterNamesEnum.Power:
        return getPowerFilterOptions();
      case FilterNamesEnum.Tag:
        return getTagFilterOptions(this.tags);
      case FilterNamesEnum.Language:
        return this.getSortedLangFilterOptions();
      case FilterNamesEnum.Equipment:
        return getEquipmentFilterOptions(sport);
      case FilterNamesEnum.InApp:
        return getInAppFilterOptions();
      case FilterNamesEnum.ClimbCategory:
        return getClimbCategoryFilterOptions();
      // case FilterNamesEnum.Vehicle:
      //   return getVehicleFilterOptions(this.vehicles);
      case FilterNamesEnum.Region:
        return getRegionFilterOptions();
    }
  }

  private getSortedLangFilterOptions(): FilterOption[] {
    return getLangFilterOptions().sort((option1, option2) => {
      return this.translateService
        .instant(option1.label)
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '') <
        this.translateService
          .instant(option2.label)
          .toLowerCase()
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
        ? -1
        : +1;
    });
  }
}
